module.exports = __webpack_public_path__ + "media/images/ESQ-1-40810e04f997496f6975a9e8d874885f.png";